import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center" }


export default /*@__PURE__*/_defineComponent({
  __name: 'MDiscordButton',
  props: {
    variant: {},
    size: {},
    class: {},
    long: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_MRainbowButton = _resolveComponent("MRainbowButton")!
  const _component_MMotionButton = _resolveComponent("MMotionButton")!

  return (__props.variant === 'cult')
    ? (_openBlock(), _createBlock(_component_MRainbowButton, {
        key: 0,
        variant: "cult",
        surface: "fancy",
        size: "lg",
        href: "https://discord.gg/MassiveMonster",
        target: "_blank",
        class: _normalizeClass(_ctx.$props.class)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "font-bold pr-2" }, " Join Discord ", -1)),
            _createVNode(_component_Icon, {
              name: "fa6-brands:discord",
              class: "text-white",
              "aria-hidden": "true"
            })
          ])
        ]),
        _: 1
      }, 8, ["class"]))
    : (_openBlock(), _createBlock(_component_MMotionButton, {
        key: 1,
        "trailing-icon": "fa6-brands:discord",
        variant: "fancy",
        class: _normalizeClass(_ctx.$props.class),
        href: "https://discord.gg/MassiveMonster",
        target: "_blank",
        size: __props.size ?? 'lg',
        long: __props.variant === 'header' ? false : __props.long ?? true
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: _normalizeClass({ uppercase: __props.variant === 'header' })
          }, " Join Discord ", 2)
        ]),
        _: 1
      }, 8, ["class", "size", "long"]))
}
}

})